<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>新一代信息技术专利</el-breadcrumb-item>
            <el-breadcrumb-item>导入管理</el-breadcrumb-item>
        </el-breadcrumb>


        <!-- 卡片视图 -->
        <el-card>
            <el-row>
                <el-button type="success" @click="showUploadVisible = true" icon="el-icon-upload2">导入专利</el-button>
            </el-row>


            <!-- 表格数据 -->
            <el-table :data="importInfoList" border stripe>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="批次编号" prop="simpleTitle"></el-table-column>
                <el-table-column label="文件名" prop="fileName"></el-table-column>
                <el-table-column label="总数量（件）" prop="ptTotal" width="120px"></el-table-column>
                <el-table-column label="成功数" prop="successNum" width="90px"></el-table-column>
                <el-table-column label="失败数" prop="failureNum" width="90px">
                    <template slot-scope="scope">
                        <el-tag type="danger" @click="showError(2, scope.row.jobSn)">{{scope.row.failureNum}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="无效数" prop="invalidNum" width="90px">
                    <template slot-scope="scope">
                        <el-tag type="danger" @click="showError(0, scope.row.jobSn)">{{scope.row.invalidNum}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="重复数" prop="multipleNum" width="90px">
                    <template slot-scope="scope">
                        <el-tag type="danger" @click="showError(1, scope.row.jobSn)">{{scope.row.multipleNum}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="导入状态" width="90px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.jobStatus === 0">导入中</el-tag>
                        <el-tag v-else-if="scope.row.jobStatus === 1" type="success">已完成</el-tag>
                        <el-tag v-else-if="scope.row.jobStatus === 2" type="info">已取消</el-tag>
                        <el-tag v-else-if="scope.row.jobStatus === 3" type="danger">异常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="导入时间" prop="createTime" width="160px"></el-table-column>
                <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.jobStatus === 0" class="item" effect="dark" content="停止导入" placement="top" :enterable="false">
                            <el-button type="warning" icon="el-icon-video-pause" size="mini"
                                @click="stopImport(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.jobStatus !== 0" class="item" effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                @click="deleteRecord(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页组件 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNo" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </el-card>

        <el-dialog title="导入专利" :visible.sync="showUploadVisible" v-if="showUploadVisible" width="30%">
            <v-patent-info-upload @uploadOk="batchAddPatentSuccess" ref="patentInfoUploadRef"></v-patent-info-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showUploadVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadNow">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="申请号列表" :visible.sync="showErrorVisible" v-if="showErrorVisible" width="30%">
            <el-input type="textarea" v-model="errorAppno" disabled></el-input>
        </el-dialog>
    </div>
</template>
  
<script>
import vPatentInfoUpload from './XxPatentInfoUpload.vue';
export default {
    components: {
        vPatentInfoUpload
    },
    data() {
        return {
            showErrorVisible: false,
            showUploadVisible: false,
            queryParams: {
                queryStr: "",
                pageNo: 1,
                pageSize: 10,
                mtype: 30
            },
            total: 0,
            importInfoList: [],
            errorAppno: ''
        }
    },
    created() {

    },
    mounted() {
        this.getJobist();
    },
    methods: {
        handleSizeChange(newSize) {
            this.queryParams.pageSize = newSize;
            this.getJobist();
        },
        handleCurrentChange(newPage) {
            this.queryParams.pageNo = newPage;
            this.getJobist();
        },
        async getJobist() {
            const { data: res } = await this.$http.get("job/find/byPage", {
                params: this.queryParams,
            });
            if (res.code == 0) {
                this.importInfoList = res.data.list;
                this.total = res.data.total;
            } else {
                this.$message.error(res.msg);
            }
        },
        async deleteRecord(job) {
            const confirmResult = await this.$confirm("是否确认删除该记录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).catch((err) => err);
            if (confirmResult !== "confirm") {
                return this.$message.info("已取消操作");
            }
            const { data: res } = await this.$http.delete("job/remove/" + job.id);
            if (res.code == 0) {
                this.$message.success('操作成功');
                this.getJobist();
            } else {
                this.$message.error(res.msg);
            }
        },
        async stopImport(job) {
            const confirmResult = await this.$confirm("是否确认停止该任务?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).catch((err) => err);
            if (confirmResult !== "confirm") {
                return this.$message.info("已取消操作");
            }
            const { data: res } = await this.$http.get("file/task/stop", {
                params: {
                    sn: job.jobSn
                }
            });
            if (res.code == 0) {
                this.$message.success('操作成功');
                this.getJobist();
            } else {
                this.$message.error(res.msg);
            }
        },
        uploadNow() {
            this.$refs.patentInfoUploadRef.submitUpload();
        },
        batchAddPatentSuccess() {
            this.showUploadVisible = false,
            this.getJobist();
        },
        async showError(type, jobSn) {
            const { data: res } = await this.$http.get("job/find/error/appno", {
                params: {
                    jobSn: jobSn,
                    errorType: type
                }
            });
            if (res.code == 0) {
                this.errorAppno = res.data;
                this.showErrorVisible = true;
            } else {
                this.$message.error(res.msg);
            }
        }
    }
}
</script>
  
<style lang="less" scoped>

</style>